<template>
<div>
    <!-- NAVBAR -->
    <nav class="navbar navbar-expand-lg navbar-dark navbar-togglable fixed-top">
      <div class="container">
        <a class="navbar-brand navbar-brand-shimmer" href="/">
            {{ $state.siteName }}
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse navbar-text-shadow" id="navbarCollapse">
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fe fe-x"></i>
          </button>
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
                <router-link to="/cache-api" class="nav-link" exact-active-class="active">Cache API</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/datasets" class="nav-link" exact-active-class="active">Datasets</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/mcp" class="nav-link" exact-active-class="active">MCP</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/status" class="nav-link" exact-active-class="active">Status</router-link>
            </li>
            <!-- <li class="nav-item">
                <router-link to="/docs" class="nav-link" exact-active-class="active">Docs</router-link>
            </li> -->
            <li class="nav-item">
                <router-link to="/faq" class="nav-link" exact-active-class="active">FAQ</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/reviews" class="nav-link" exact-active-class="active">Reviews</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/blog" class="nav-link" exact-active-class="active">Blog</router-link>
            </li>
          </ul>
          <router-link :to="{path: '/dashboard'}" class="navbar-btn btn btn-sm btn-primary lift ms-auto" v-if="$state.context.id">Console</router-link>
          <ul class="navbar-nav ms-auto" v-else>
              <li class="nav-item">
                  <router-link :to="{path: '/registration'}" class="navbar-btn btn btn-sm btn-primary lift ms-auto">Register</router-link>
              </li>
              <li class="nav-item">
                  <router-link :to="{path: '/login'}" class="nav-link">Login</router-link>
              </li>
          </ul>
        </div>
      </div>
    </nav>
    <main>
        <router-view></router-view>
    </main>
    <footer class="footer py-8 py-md-11 border-top border-secondary">
        <Footer />
    </footer>
</div>
</template>

<script>
import Footer from './Footer.vue'
export default {
    components: { Footer },
}
</script>
